import { useState } from "react";
import { heroData, updateBarData } from "@/mocks/home";

export default function SiteFooter() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(heroData.backupHost);
    } catch {
      /* clipboard unavailable — still give local feedback */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2400);
  };

  return (
    <footer className="w-full bg-accent-950 text-background-50">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1.4fr_1fr] lg:gap-20">
          <div>
            <h2 className="font-heading text-3xl font-black text-background-50 md:text-5xl">
              黑料地址
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-300 md:text-base">
              记住这个页面，比记住任何一个域名都更稳妥。无论黑料地址的镜像域名如何轮换，
              回到这里，你总能找到当下最新的黑料地址备用入口。
            </p>

            <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={handleCopy}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                <i className={copied ? "ri-check-line text-base" : "ri-file-copy-line text-base"}></i>
                {copied ? "备用入口已复制" : "复制备用入口"}
              </button>
              <a
                href="#mirrors"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-background-50/10"
              >
                <i className="ri-list-check-3 text-base"></i>
                回到镜像列表
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <p className="font-label text-xs tracking-[0.2em] text-background-400">本页内容</p>
              <ul className="mt-4 space-y-3 text-sm text-background-200">
                <li>
                  <a href="#entries" className="transition-colors hover:text-background-50">
                    今日主推入口
                  </a>
                </li>
                <li>
                  <a href="#mirrors" className="transition-colors hover:text-background-50">
                    可用镜像域名
                  </a>
                </li>
                <li>
                  <a href="#ranking" className="transition-colors hover:text-background-50">
                    本周热度榜
                  </a>
                </li>
                <li>
                  <a href="#faq" className="transition-colors hover:text-background-50">
                    常见问题
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-label text-xs tracking-[0.2em] text-background-400">运行状态</p>
              <ul className="mt-4 space-y-3 text-sm text-background-200">
                <li className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-primary-400"></i>
                  防封备用已开启
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-refresh-line text-primary-400"></i>
                  自动校验每 30 分钟
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-history-line text-primary-400"></i>
                  最近 {updateBarData.checkedAt}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-background-50/15 pt-8 text-xs text-background-400 md:flex-row md:items-center md:justify-between md:text-sm">
          <p>© {new Date().getFullYear()} 黑料地址网 · 地址索引页，仅提供导航信息。</p>
          <p>收藏本页，换域名也能找到 · 防封备用 · 最新镜像持续更新</p>
        </div>
      </div>
    </footer>
  );
}